export const Status = Object.freeze({
	PROCESSED: "processed",
	PENDING: "pending",
	DECLINED: "declined",
	EXPIRED: "expired",
	WAITING: "waiting",
	ONPROCESS: "processing",
	APPROVED: "approved",
});
